/**
 * Informational note for org admins on the Manage Your Teams page listing
 * the email domains that allow users to be added to teams directly (without
 * an invite). Renders nothing when the org has no configured domains; the
 * parent gates on org-admin visibility.
 */
export const AllowedEmailDomainsBanner = ({ domains }) => {
  if (!domains?.length) {
    return null;
  }

  return (
    <p
      className="font-normal text-secondary rounded-standard p-sm mb-sm"
      data-testid="allowed-email-domains-banner"
    >
      Users with an approved email domain can be added to teams
      directly:{" "}
      {domains.map((domain, index) => (
        <span key={domain}>
          <span className="font-medium text-primary">@{domain}</span>
          {index < domains.length - 1 ? ", " : ""}
        </span>
      ))}
    </p>
  );
};
